import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { useWatch, Controller } from "react-hook-form";


const CheckboxGroup = ({
  config,
  control,
  label,
  name,
  options,
  row,
  ...props
}) => {
  const checkboxIds = useWatch({ control, name: name }) || [];

  const handleChange = (field, value) => {
    const newArray = [...checkboxIds];
    const item = value;

    //Ensure array isnt empty
    if (newArray.length > 0) {
      //Attempt to find an item in array with matching id
      const index = newArray.findIndex((x) => x === item);

      // If theres no match add item to the array
      if (index === -1) {
        newArray.push(item);
      } else {
        //If there is a match and the value is empty, remove the item from the array
        newArray.splice(index, 1);
      }
    } else {
      //If the array is empty, add the item to the array
      newArray.push(item);
    }

    //Overwrite existing array with newArray}
    field.onChange(newArray);
  };

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field }) => <FormControl className={props?.className}>
          <FormGroup row={row}>
            {options.map((option) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={(field?.value ?? [])?.some(
                      (checked) => checked === option[config.value]
                    )}
                    onChange={() => handleChange(field, option[config.value])}
                    disabled={props?.disabled}
                  />
                }
                label={<p className="body2">{option[config.label]}</p>}
                key={option[config.value]}
              />
            ))}
          </FormGroup>
        </FormControl>}>
      </Controller>
    </div>
  );
};

export default CheckboxGroup;
